import React from "react";
import FormLabel from "../Typography/FormLabel";
import classNames from "classnames";
import { FormGroup, TextInput } from "./styles";

const FormInput = ({
  children,
  textLabelColor,
  bold,
  label,
  margin,
  bg,
  textcolor,
  mb,
  border,
  br,
  size,
  padding,
  center,
  className,
  ...props
}) => {
  return (
    <FormGroup mb={mb}>
      {label != undefined &&
        <FormLabel textLabelColor={textLabelColor} bold={bold} margin={margin}>
          {label}
        </FormLabel>
      }
      <TextInput bg={bg} br={br} center={center} textcolor={textcolor} border={border} padding={padding} size={size} bold={bold}  className={classNames(className)} {...props}>
        {children}
      </TextInput>
    </FormGroup>
  );
};

export default FormInput;
